import { Injectable, OnDestroy } from '@angular/core';
import { Subscription, fromEvent, merge, timer, Subject } from 'rxjs';
import { switchMap, startWith, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../data-services/authentication.service';
import { UserService } from './user.services';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService implements OnDestroy {
  private idleTimerSubscription?: Subscription;
  private readonly IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
  private destroy$ = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService
  ) {}

  startTimer(): void {
    if (this.idleTimerSubscription && !this.idleTimerSubscription.closed) {
      return;
    }

    const userActivityEvents$ = merge(
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'keydown'),
      fromEvent(window, 'click'),
      fromEvent(window, 'scroll'),
      fromEvent(window, 'touchstart')
    );

   this.idleTimerSubscription = userActivityEvents$.pipe(
  startWith(null),
  switchMap(() => {
    return timer(this.IDLE_TIMEOUT_MS);
  }),
  takeUntil(this.destroy$)
).subscribe(() => {

  this.handleTimeout();
});
  }

  stopTimer(): void {
    if (this.idleTimerSubscription) {
      this.idleTimerSubscription.unsubscribe();
      this.idleTimerSubscription = undefined;
    }
  }

  private handleTimeout(): void {
    if (!this.userService.isLoggedIn()) {
      this.stopTimer();
      return;
    }

    this.authenticationService.logout().subscribe({
      next: () => {
        this.userService.logout();
      },
      error: () => {
        this.userService.logout();
      }
    });
    this.stopTimer();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.stopTimer();
  }
}
